import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Users, TrendingUp, Handshake } from 'lucide-react';
const stats = [{
  icon: Globe,
  value: 'Worldwide',
  label: 'Global Operations',
  description: 'Serving international markets across continents'
}, {
  icon: Users,
  value: 'Trusted',
  label: 'Global Supplier',
  description: 'Reliable partner for investors and buyers'
}, {
  icon: TrendingUp,
  value: 'Premium',
  label: 'Quality Standards',
  description: 'Highest grade minerals and gemstones'
}, {
  icon: Handshake,
  value: 'Professional',
  label: 'Partnerships',
  description: 'Building long-term business relationships'
}];
export function GlobalOperations() {
  return <section id="operations" className="py-24 bg-gray-900 text-white relative overflow-hidden" data-id="element-120">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-121">
        <div className="absolute inset-0" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }} data-id="element-122" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-123">
        <div className="text-center mb-16" data-id="element-124">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-4xl md:text-5xl font-bold mb-4" data-id="element-125">
            Global Operations
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-126">
            From the heart of the RDC to international markets worldwide. We are
            your trusted partner for premium minerals, serving investors,
            buyers, and global partners with professionalism and integrity.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-127">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-128">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-yellow-400 to-yellow-600 mb-4" data-id="element-129">
                <stat.icon size={32} className="text-gray-900" data-id="element-130" />
              </div>
              <h3 className="text-2xl font-bold mb-2" data-id="element-131">{stat.value}</h3>
              <p className="text-lg font-semibold text-gray-200 mb-2" data-id="element-132">
                {stat.label}
              </p>
              <p className="text-sm text-gray-400" data-id="element-133">{stat.description}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-16 text-center" data-id="element-134">
          <div className="inline-block bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-3xl" data-id="element-135">
            <p className="text-lg text-gray-200 leading-relaxed" data-id="element-136">
              Kale Cooperative Minerals SPRL operates with full transparency and
              compliance with international mining standards. Our commitment to
              ethical sourcing and quality assurance has made us a trusted name
              in the global mineral trade industry.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}